import { gsap } from 'gsap';
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

const initGSAPTimeline = () => {
	const wrapper = document.querySelector('.hoffman-timeline');

	if (!wrapper) return;

	const slides = wrapper.querySelectorAll('.hoffman-timeline__slide');
	const buttons = wrapper.querySelectorAll('.hoffman-timeline__btn');

	if (!slides.length || !buttons.length) return;

	let activeIndex = 0;
	let isAnimating = false;

	const goToSlide = (nextIndex) => {
		if (nextIndex === activeIndex || isAnimating) return;
		isAnimating = true;

		const currentSlide = slides[activeIndex];
		const nextSlide = slides[nextIndex];
		const direction = nextIndex > activeIndex ? 1 : -1;

		buttons[activeIndex].classList.remove('is-active');
		buttons[activeIndex].setAttribute('aria-selected', 'false');
		buttons[nextIndex].classList.add('is-active');
		buttons[nextIndex].setAttribute('aria-selected', 'true');
		nextSlide.inert = false;

		// set up next slide
		gsap.set(nextSlide, {
			display: 'block',
			xPercent: direction * 100,
			opacity: 0,
		});

		// main slide animation timeline
		const sliderTL = gsap.timeline({
			onStart: () => {
				const currentSlideHeight = nextSlide.clientHeight;
				gsap.to('.hoffman-timeline__stage', {
					height: currentSlideHeight,
					duration: 0.6,
					ease: 'power2.inOut',
				})
			},
			onComplete: () => {
				currentSlide.inert = true;
				gsap.set(currentSlide, { display: 'none' });
				activeIndex = nextIndex;
				isAnimating = false;
			},
		});

		sliderTL.to(currentSlide, {
			xPercent: direction * -100,
			opacity: 0,
			duration: 0.45,
			ease: 'power3.inOut',
		}).to(
			nextSlide,
			{
				xPercent: 0,
				opacity: 1,
				duration: 0.45,
				ease: 'power3.inOut',
			},
			'<0.1'
		);
	};

	// show first slide on init
	gsap.set(slides[0], { display: 'block', xPercent: 0, opacity: 1 });
	gsap.set('.hoffman-timeline__stage', {
		height: slides[0].clientHeight,
	});
	setTimeout(() => {
		gsap.set('.hoffman-timeline__stage', {
			height: slides[0].clientHeight,
		});
	}, 100);
	slides[0].inert = false;

	// hide all other slides on init
	slides.forEach((slide, i) => {
		if (i !== 0) {
			slide.inert = true;
			gsap.set(slide, { display: 'none', xPercent: 100, opacity: 0 });
		}
	});

	// enable initial nav state for first button
	buttons[0].classList.add('is-active');
	buttons[0].setAttribute('aria-selected', 'true');

	// hook up nav
	buttons.forEach((btn, i) => {
		btn.addEventListener('click', () => {
			goToSlide(i);
		const track = document.querySelector('.hoffman-timeline__track');
		const activeBtn = btn;
		if (activeBtn) {
			const btnOffset = activeBtn.getBoundingClientRect().left;
			const trackOffset = track.getBoundingClientRect().left;
			const leftOffset = btnOffset - trackOffset;
			track.style.setProperty('--dotOffset', `${leftOffset}px`);
		}
		});
	});

// nav animation
	gsap.fromTo(
		buttons,
		{ autoAlpha: 0, x: -10 },
		{
			autoAlpha: 1,
			x: 0,
			duration: 0.9,
			ease: "power3.out",
			stagger: 0.1,
			scrollTrigger: {
				trigger: '.hoffman-timeline__nav',
				start: "top 90%",
				end: "bottom 50%",
				toggleActions: "play none none reverse",
			}
		}
	);



};

export { initGSAPTimeline };
